import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // apiUrlEmployee: "http://localhost:4320/api",
    // apiUrlRegister: "http://5.5.5.10:4300/api",
    // apiUrl: "http://5.5.5.10:5100/api",

    // apiUrl: "http://localhost:5100/api",
    apiUrl: "https://ar.al-turath.university/api",

    // apiUrlLocal: "http://localhost:4320/api",
    // apiUrl: "https://archive.al-turath.university/api",
    // apiUrlEmployee: "https://hr.al-turath.university/api",
    apiUrlEmployee: "https://employee.al-turath.university/api",
    apiUrlRegister: "https://register.al-turath.university/api",
    selectedYear: 0,
    user: null,
    userData: null,
    employee: null,
    provinces: null,
    academicTitles: null,
    certificates: null,
    contractTypes: null,
    roles: null,
    subjects: [],
    sections: [],
    genders: [
      { name: "ذكر", id: 1 },
      { name: "انثى", id: 2 },
    ],
    oldArchiveTypes: [
      { id: 1, name: "صادر" },
      { id: 2, name: "وارد" },
    ],
    counts: null,
    insideOriginalArray: [],
  },
  mutations: {
    GET_USER_DATA(state, userData) {
      state.user = userData;
    },
  },
  actions: {
    getUserDate({ commit }) {
      // Old localStorage code (commented out)
      // let data = localStorage.getItem("archive");
      // if (data) {
      //   var base64Url = data.split(".")[1];
      //   var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      //   var jsonPayload = decodeURIComponent(
      //     atob(base64)
      //       .split("")
      //       .map(function (c) {
      //         return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      //       })
      //       .join("")
      //   );
      //   let text = JSON.parse(jsonPayload);
      //   console.log(text);
      //   this.state.userData = text;
      // }
      // commit("GET_USER_DATA", JSON.parse(data));

      // Now we only check if user exists in Vuex state
      return Promise.resolve(this.state.user);
    },

    fetchInitialData({ state }) {
      // Fetch all initial data after login
      const Vue = require("vue").default;
      const axios = Vue.prototype.$http;

      if (!state.user) return;

      const headers = { Authorization: `Bearer ${state.user}` };

      // Fetch certificates
      axios.get(`${state.apiUrlEmployee}/certificates`, { headers }).then((res) => {
        state.certificates = res.data;
      });

      // Fetch academic titles
      axios.get(`${state.apiUrlEmployee}/academicTitles`, { headers }).then((res) => {
        state.academicTitles = res.data;
      });

      // Fetch roles
      axios.get(`${state.apiUrlEmployee}/roles`, { headers }).then((res) => {
        state.roles = res.data;
      });

      // Fetch provinces
      axios.get(`${state.apiUrlEmployee}/provinces`, { headers }).then((res) => {
        state.provinces = res.data;
      });

      // Fetch contract types
      axios.get(`${state.apiUrlEmployee}/contractTypes`, { headers }).then((res) => {
        state.contractTypes = res.data;
      });

      // Fetch sections
      axios.get(`${state.apiUrlRegister}/allSections`, { headers }).then((res) => {
        state.sections = res.data;
      });
    },
  },
  modules: {},
});

//SELECT * FROM `StudentPayment` JOIN turath_db_new.Student ON turath_db_new.Student.collegeNumber = StudentPayment.collegeNumber WHERE turath_db_new.Student.studentStatusId = 3 AND StudentPayment.studyYearId = 74 AND paymentTypeId < 10 GROUP BY StudentPayment.collegeNumber
